export default __webpack_public_path__ + "static/media/capitalOne.4efbd848.svg";